import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';
import { DateService } from '../../services/date-service';
import { twelveHourUserSetting } from '../../constants/timezone-format';

const UserTimeFormat = ({ userTimeFormat = twelveHourUserSetting, timeZone = '', value }) => {
  const props = {
    hour12: DateService.isTwelveHourFormat(userTimeFormat),
    value: value || new Date(),
    ...(timeZone && { timeZone }),
  };

  return <FormattedTime {...props} />;
};

UserTimeFormat.propTypes = {
  userTimeFormat: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  timeZone: PropTypes.string,
};

export default UserTimeFormat;
